import uiBase from "../uiBase";
import css from "./node.scss";
const { h, Component, classNames, render, define } = omii;
/**
 * node {
 * key,
 * label,
 * element,
 * expanded
 * checked
 * allowCheck
 * }
 */
class TreeNode extends uiBase {
  static css = css;
  static defaultProps = {
    nodeLevel: 0,
    ignoreAttrs: true,
  };
  static propTypes = {
    nodeLevel: Number,
    ignoreAttrs: Boolean,
  };

  get tree() {
    return this.props.tree;
  }

  get checkboxTree() {
    return this.tree.props.checkboxTree;
  }

  get radioTree() {
    return this.tree.props.radioTree;
  }

  get selected() {
    return this.node.checked ?? this.tree.isSelected(this.key);
  }

  get checked() {
    return this.node.checked ?? this.tree.isChecked(this.key);
  }

  get radioed() {
    return this.node.radioed ?? this.tree.isRadioed(this.key);
  }
  get expanded() {
    return this.node.expanded ?? this.tree.isExpanded(this.key);
  }

  get node() {
    return this.props.node ?? {};
  }
  get key() {
    return this.node.key ?? `node-${this.elementId}`;
  }
  get level() {
    return this.props.nodeLevel ?? 0;
  }
  #isloading = false;
  expand() {
    this.tree.expand(this.key, false);
    this.node.expanded = true;
    this.updateSelf();
    this.tree.fire("nodeExpand", { node: this.node, treeNode: this });
  }
  collapse() {
    this.tree.collapse(this.key, false);
    this.node.expanded = false;
    this.updateSelf();
    this.tree.fire("nodeCollapse", { node: this.node, treeNode: this });
  }
  select() {
    this.tree.select(this.key, false);
    if (this.tree.props.multiSelect) {
      this.updateSelf();
    } else {
      if (this.tree.__selectedNode) {
        this.tree.__selectedNode.updateSelf();
      }
      this.tree.__selectedNode = this;
      this.updateSelf();
    }
    this.tree.fire("nodeSelect", { node: this.node, treeNode: this });
  }
  unSelect() {
    this.tree.unSelect(this.key, false);
    this.updateSelf();
    this.tree.fire("nodeUnSelect", { node: this.node, treeNode: this });
  }
  check() {
    this.tree.check(this.key, false);
    this.tree.fire("nodeCheck", { node: this.node, treeNode: this });
  }
  uncheck() {
    this.tree.uncheck(this.key, false);
    this.tree.fire("nodeUnCheck", { node: this.node, treeNode: this });
  }
  radio() {
    this.tree.radio(this.key, false);
    this.tree.fire("nodeRadio", { node: this.node, treeNode: this });
    if (this.tree.__radioedNode) {
      this.tree.__radioedNode.updateSelf();
    }
    this.tree.__radioedNode = this;
  }
  unradio() {
    this.tree.unradio(this.key, false);
    this.tree.fire("nodeUnRadio", { node: this.node, treeNode: this });
  }
  get noChildren() {
    return !this.node.children;
  }
  toggle() {
    if (this.expanded) this.collapse();
    else this.expand();
  }
  get $checkbox() {
    return this.checkboxTree ? (
      this.node.allowCheck !== false ? (
        <input
          type="checkbox"
          disabled={this.node.disabled === true}
          checked={this.checked}
          onClick={(evt) => {
            evt.stopPropagation();
          }}
          onChange={(evt) => {
            if (evt.currentTarget.checked) {
              this.check();
            } else {
              this.uncheck();
            }
          }}
        />
      ) : (
        <div class="checkbox-placeholder" />
      )
    ) : null;
  }
  get $radio() {
    if (this.radioed) this.tree.__radioedNode = this;
    return this.radioTree ? (
      this.node.allowCheck !== false ? (
        <input
          type="radio"
          disabled={this.node.disabled === true}
          checked={this.radioed}
          onClick={(evt) => {
            evt.stopPropagation();
          }}
          onChange={(evt) => {
            if (evt.currentTarget.checked) {
              this.radio();
            } else {
              this.unradio();
            }
          }}
        />
      ) : (
        <div class="radio-placeholder" />
      )
    ) : null;
  }
  async render(props) {
    let { node } = props;
    let $element = node.__element ?? node.element ?? node.label;
    if (typeof $element == "function") {
      $element = node.__element = await $element();
    }
    let children = node.__children ?? node.children ?? [];
    if (typeof children === "function") {
      if (this.expanded) {
        let result = children(props, this);
        if (result[Symbol.toStringTag] === "Promise") {
          this.#isloading = true;
          children = [];
          result.then((r) => {
            node.__children = r;
            this.#isloading = false;
            this.updateSelf();
          });
        } else {
          children = node.__children = result;
        }
      } else {
        children = [];
      }
    }

    return (
      <div
        class={classNames("node", {
          expanded: this.expanded,
          "loading-children": this.#isloading,
          "no-children": this.noChildren,
        })}
      >
        <div
          class={classNames("element", { selected: this.selected })}
          style={`padding-left:calc(${this.level} * var(--oi-tree-node-indent,1rem))`}
          onClick={() => {
            if (this.selected) this.unSelect();
            else this.select();
          }}
        >
          <div
            onClick={(evt) => {
              evt.stopPropagation();
              this.toggle();
            }}
            class={classNames("expander", { "no-children": this.noChildren })}
          >
            <oi-icon name="arrow_right" />
          </div>
          {this.$checkbox}
          {this.$radio}
          {$element}
          {this.#isloading ? <oi-loading /> : null}
        </div>
        <div class="children">
          {children.map((child) => (
            <oi-tree-node
              node={child}
              node-level={this.level + 1}
              tree={this.tree}
            />
          ))}
        </div>
      </div>
    );
  }
}

define("oi-tree-node", TreeNode);
export default TreeNode;
